import { cloneableFactory } from "../cloneable";
import { modal } from "../modal";
import { filePickerFactory } from "./filePicker";
import { EventEmitter } from "../../events/eventEmitter";
class MultipleFilePicker extends EventEmitter {
    constructor(fileTable, container) {
        super();
        const picker = $($(fileTable).data("picker-selector"), container);
        const [pickerModel] = filePickerFactory.getModels(picker);
        this.cloneable = cloneableFactory.make({
            container: fileTable,
            itemSelector: "[data-file-row]",
            removeSelector: "[data-remove-file]",
            scope: container,
        });
        this.subscriptions = [
            this.cloneable.on("itemAdded", (row) => this.initialiseNewRow(row)),
            this.cloneable.on("itemRemoved", () => this.emit("fileRemoved")),
            pickerModel.on("tempFilesUploaded", (files) => this.addFiles(files)),
        ];
    }
    cleanUp() {
        cloneableFactory.destroy(this.cloneable);
        this.subscriptions.forEach((s) => s.off());
    }
    initialiseNewRow(row) {
        $(row).removeClass("hidden");
        this.emit("fileAdded");
    }
    addFiles(files) {
        files.forEach((f) => {
            const row = this.cloneable.addItem();
            $("input.upload-temp-file-name", row).val(f.TempFileName);
            $("input.upload-original-file-name", row).val(f.OriginalFileName);
            $("span.upload-original-file-name", row).text(f.OriginalFileName);
        });
    }
}
class MultipleFilePickerFactory {
    initialise(container) {
        const fileTables = $(container).find("[data-files-table]");
        fileTables.toArray().forEach((t) => {
            const fileTable = $(t);
            if (!fileTable.data("multiple-file-picker-model")) {
                const filePicker = new MultipleFilePicker(fileTable[0], container);
                fileTable.data("multiple-file-picker-model", filePicker);
            }
        });
    }
    cleanUp(container) {
        const fileTables = $(container).find("[data-files-table]");
        fileTables.toArray().forEach((p) => {
            const model = ($(p).data("multiple-file-picker-model"));
            model && model.cleanUp();
        });
    }
    getModels(pickerTables) {
        return pickerTables
            .toArray()
            .map((p) => $(p).data("multiple-file-picker-model"))
            .filter((m) => !!m);
    }
}
export const multipleFilePickerFactory = new MultipleFilePickerFactory();
modal.on("show", (modal) => multipleFilePickerFactory.initialise(modal));
modal.on("hide", (modal) => multipleFilePickerFactory.cleanUp(modal));
cloneableFactory.on("itemAdded", (row) => multipleFilePickerFactory.initialise(row));
cloneableFactory.on("itemRemoved", (row) => multipleFilePickerFactory.cleanUp(row));
$(() => multipleFilePickerFactory.initialise(document));
